import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll, postApproval } from "./qahoAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  approval: [],
};

export const fetchAll = createAsyncThunk("qaho/fetchAll", async (payload) => {
  const response = await getAll(payload);
  return response.data;
});

export const createApproval = createAsyncThunk(
  "qaho/createApproval",
  async (payload) => {
    const response = await postApproval(payload);
    return response;
  }
);

export const qahoSlice = createSlice({
  name: "qaho",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setApproval: (state, action) => {
      state.approval = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { resetData, setSelected, setApproval } = qahoSlice.actions;

export const selectData = (state) => state.qaho.data;
export const selectLoading = (state) => state.qaho.loading;
export const selectError = (state) => state.qaho.error;
export const selectPageNo = (state) => state.qaho.pageNo;
export const selectPageSize = (state) => state.qaho.pageSize;
export const selectTotalRecord = (state) => state.qaho.totalRecord;
export const selectSelected = (state) => state.qaho.selected;
export const selectApproval = (state) => state.qaho.approval;

export default qahoSlice.reducer;
